import angular from 'angular';

import component from './who.component';

const ExperienceWho = angular
    .module('control-room.experience-promoter.components.experience-manage.components.who', [])
    .component('crExperienceWho', component);

export default ExperienceWho;
